import {
	CalcType,
	CalculationReq,
	CalculationRes,
	Customer,
	FilterDuration,
	Offer,
	OfferAttachment,
	OfferSearch,
	OfferState,
	OfferStage
} from 'api';
import * as actions from './actionTypes';

export interface IDashboardFetch {
	offerId?: number;
	offerType?: CalcType;
	portfolioId?: number;
	user?: string;
	regionalManager?: string;
	offerState?: OfferState;
	offerStage?: OfferStage;
	duration?: FilterDuration;
}

export const lockOfferForm = () => ({
	type: actions.LOCK_OFFER_FORM
});

export const unlockOfferForm = () => ({
	type: actions.UNLOCK_OFFER_FORM
});

export const offerGet = (id: number) => ({
	type: actions.GET_OFFER,
	payload: id
});

export const offerGetAll = () => ({
	type: actions.GET_OFFERS_ALL
});

export const getDashboardOffers = ({
	offerId,
	offerType,
	portfolioId,
	user,
	regionalManager,
	offerState,
	offerStage,
	duration
}: IDashboardFetch) => ({
	payload: {
		offerID: offerId,
		offerType: offerType,
		portfolioID: portfolioId,
		user: user,
		regionalManager,
		state: offerState,
		status: offerStage,
		duration
	},
	type: actions.GET_DASHBOARD_OFFERS
});

export const getDashboardData = ({
	offerId,
	offerType,
	portfolioId,
	user,
	regionalManager,
	offerState,
	offerStage,
	duration
}: IDashboardFetch) => ({
	payload: {
		offerID: offerId,
		offerType: offerType,
		portfolioID: portfolioId,
		user: user,
		regionalManager,
		state: offerState,
		status: offerStage,
		duration
	},
	type: actions.GET_DASHBOARD_DATA
});

export const offerSearch = (filter?: OfferSearch) => ({
	type: actions.GET_OFFERS_SEARCH,
	payload: filter
});

export const offerSave = (offer: Offer, files: any[]) => ({
	type: actions.OFFER_SAVE,
	payload: {
		offer,
		files
	}
});

export const offerUpdate = (offer: Offer, files: any[]) => ({
	type: actions.OFFER_UPDATE,
	payload: {
		offer,
		files
	}
});

export const setOffer = (offer: Offer) => ({
	// IOfferData
	type: actions.SET_OFFER,
	payload: offer
});

export const setOfferFiles = (attachments: OfferAttachment[]) => ({
	// IOfferData
	type: actions.SET_OFFER_FILES,
	payload: attachments
});

export const offerCalculate = (calcData: CalculationReq) => ({
	// IOfferData
	type: actions.OFFER_CALCULATE,
	payload: calcData
});

export const offerCalculateSuccess = (calcData: CalculationRes) => ({
	// IOfferData
	type: actions.OFFER_CALCULATE_SUCCESS,
	payload: calcData
});

export const offerCalculateReset = () => ({
	// IOfferData
	type: actions.OFFER_CALCULATE_RESET
});

export const setOffers = (offers: Offer[]) => ({
	// IOfferData[]
	type: actions.SET_OFFERS,
	payload: offers
});
export const setChartOffers = (offers: Offer[]) => ({
	// IOfferData[]
	type: actions.SET_CHART_OFFERS,
	payload: offers
});

export const customerDataGet = (
	ident: string,
	value: string,
	calcType?: CalcType,
	isAquisition?: boolean
) => ({
	type: actions.GET_CUSTOMER_DATA,
	payload: { ident, value, calcType, isAquisition }
});

export const customerDataSet = (customerData: Customer) => ({
	type: actions.SET_CUSTOMER_DATA,
	payload: customerData
});

export const offerError = (error: string) => ({
	type: actions.OFFERS_ERROR,
	payload: error
});

export const offerClearError = () => ({
	type: actions.OFFER_CLEAR_ERROR
});

export const offerReset = () => ({
	type: actions.OFFER_RESET
});

export const offerResetAll = () => ({
	type: actions.OFFER_RESET_ALL
});

export const offerUnlock = (id: number) => ({
	id: id,
	type: actions.UNLOCK_OFFER
});

export const uploadAttach = (offerId: number, payload: OfferAttachment) => ({
	offerId,
	payload,
	type: actions.UPLOAD_ATTACH
});

export const downloadAttach = (offerId: number, payload: number) => ({
	offerId,
	payload,
	type: actions.DOWNLOAD_ATTACH
});

export const deleteAttach = (offerId: number, payload: number) => ({
	offerId,
	payload,
	type: actions.DELETE_ATTACH
});

export const fileDownloadSuccess = (file: Blob) => {
	return {
		type: actions.PREP_FILE_DOWNLOAD_SUCCESS,
		payload: file
	};
};

export const getConstValByName = (name: string) => ({
	type: actions.GET_CONST_VALUE,
	payload: name
});
